import { defineStore } from "pinia";
import { favoriteApi } from "@/api";
import type { FavoriteItem, ApiResponse } from "@/api";
import { GAME_ID } from "./index";
export const useFavoriteStore = defineStore("favorite", {
  state: () => ({
    // 收藏列表
    favoriteList: [] as FavoriteItem[],
    // 加载状态
    loading: false,
    // 加载更多状态
    loadingMore: false,
    // 错误信息
    error: null as string | null,
    // 分页信息
    pagination: null as any,
    // 当前页码
    currentPage: 1,
    // 每页数量
    pageSize: 10,
  }),

  getters: {
    // 是否有更多数据
    hasMore: (state) => state.pagination?.has_next || false,
  },

  actions: {
    /**
     * 获取收藏列表
     */
    async getFavoriteList(
      uid: number,
      page: number = 1,
      page_size: number = 10,
      append: boolean = false
    ) {
      if (append) {
        this.loadingMore = true;
      } else {
        this.loading = true;
        this.currentPage = 1;
      }
      this.error = null;

      try {
        const response = await favoriteApi.getList(
          uid,
          page,
          page_size,
          GAME_ID
        );
        if (response.code == 200) {
          const favorites = response.data.favorites || [];
          if (append) {
            // 追加模式：将新数据添加到现有列表
            this.favoriteList = [...this.favoriteList, ...favorites];
          } else {
            // 非追加模式：替换现有列表
            this.favoriteList = favorites;
          }

          // 更新分页信息
          this.pagination = response.data.pagination || null;
          this.currentPage = page;

          return response;
        } else {
          this.error = response.message || "获取收藏列表失败";
          throw new Error(this.error);
        }
      } catch (error) {
        this.error =
          error instanceof Error ? error.message : "获取收藏列表失败";
        throw error;
      } finally {
        if (append) {
          this.loadingMore = false;
        } else {
          this.loading = false;
        }
      }
    },

    /**
     * 收藏帖子
     */
    async addFavorite(tid: number) {
      const response = await favoriteApi.add(tid, GAME_ID);
      if (response.code == 200) {
        return response;
      }
    },

    /**
     * 取消收藏帖子
     */
    async cancelFavorite(tid: number) {
      const response = await favoriteApi.remove(tid, GAME_ID);
      if (response.code == 200) {
        return response;
      }
    },

    /**
     * 加载更多收藏
     */
    async loadMoreFavorites(uid: number) {
      if (!this.pagination?.has_next || this.loading || this.loadingMore) {
        return;
      }

      const nextPage = this.currentPage + 1;
      await this.getFavoriteList(uid, nextPage, this.pageSize, true);
    },

    /**
     * 设置收藏列表
     * @param favorites 收藏列表
     */
    setFavoriteList(favorites: FavoriteItem[]) {
      this.favoriteList = favorites;
    },

    /**
     * 批量更新收藏项关注状态，根据authorid更新
     */
    updateFavoriteFollowStatus(authorid: number, follow_action: number) {
      this.favoriteList.forEach((item) => {
        if (item.authorid === authorid) {
          item.is_author_followed = follow_action;
        }
      });
    },
  },
});
